module.exports = __webpack_public_path__ + "static/media/map_dot_highlight_layer.6df02e75.svg";